// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../next/Next.bs.js");
let Alert = require("../../../v5/common/Components/Alert.bs.js");
let React = require("react");
let PageTitle = require("../../common/PageTitle.bs.js");
let ProfilePage = require("./ProfilePage.bs.js");
let UserSession = require("../../common/UserSession/UserSession.bs.js");
let PasswordPage = require("./PasswordPage.bs.js");
let LoggedInAgent = require("../../common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../common/MarkupHelpers/MarkupHelpers.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let SubusersPageRelay = require("../../../v5/settings/SubusersPageRelay.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageSidebar = require("../../../v5/settings/SettingsPageSidebar.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let BillingSettingsPageRelay = require("../../../v5/settings/BillingSettingsPageRelay.bs.js");
let EmailPreferencesPageRelay = require("../../../v5/settings/EmailPreferencesPageRelay.bs.js");
let CreateTeamMarketingProfile = require("../../../v5/settings/CreateTeamMarketingProfile.bs.js");
let EditMarketingProfileMember = require("../../../v5/settings/EditMarketingProfileMember.bs.js");
let AddMemberToMarketingProfile = require("../../../v5/settings/AddMemberToMarketingProfile.bs.js");
let TeamMarketingProfileSettings = require("../../../v5/settings/TeamMarketingProfileSettings.bs.js");
let TeamMarketingProfileSlugForm = require("../../../v5/settings/TeamMarketingProfileSlugForm.bs.js");
let AgentMarketingProfileSettings = require("../../../v5/settings/AgentMarketingProfileSettings.bs.js");
let AgentMarketingProfileSlugForm = require("../../../v5/settings/AgentMarketingProfileSlugForm.bs.js");
let TeamMarketingProfileAboutSettings = require("../../../v5/settings/TeamMarketingProfileAboutSettings.bs.js");
let AgentMarketingProfileAboutSettings = require("../../../v5/settings/AgentMarketingProfileAboutSettings.bs.js");
let TeamMarketingProfilePhotosSettings = require("../../../v5/settings/TeamMarketingProfilePhotosSettings.bs.js");
let AgentMarketingProfilePhotosSettings = require("../../../v5/settings/AgentMarketingProfilePhotosSettings.bs.js");
let TeamMarketingProfileMembersSettings = require("../../../v5/settings/TeamMarketingProfileMembersSettings.bs.js");
let TeamMarketingProfileBasicInfoSettings = require("../../../v5/settings/TeamMarketingProfileBasicInfoSettings.bs.js");
let AgentMarketingProfileBasicInfoSettings = require("../../../v5/settings/AgentMarketingProfileBasicInfoSettings.bs.js");
let TeamMarketingProfileSocialAccountsSettings = require("../../../v5/settings/TeamMarketingProfileSocialAccountsSettings.bs.js");
let AgentMarketingProfileSocialAccountsSettings = require("../../../v5/settings/AgentMarketingProfileSocialAccountsSettings.bs.js");

function AccountSettingsPage$Page(props) {
  let __setting = props.setting;
  let setting = __setting !== undefined ? __setting : ["profile"];
  let billingEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  let tmp;
  if (setting.length !== 1) {
    tmp = "Settings";
  } else {
    let match = setting[0];
    switch (match) {
      case "billing" :
        tmp = "Billing Settings";
        break;
      case "email_notifications" :
        tmp = "Email Notifications Settings";
        break;
      case "password" :
        tmp = "Password Settings";
        break;
      case "profile" :
        tmp = "Profile Settings";
        break;
      case "users" :
        tmp = "Users Settings";
        break;
      default:
        tmp = "Settings";
    }
  }
  let len = setting.length;
  let tmp$1;
  if (len >= 5) {
    tmp$1 = "This doesn't seem to be a valid URL";
  } else {
    switch (len) {
      case 0 :
        tmp$1 = "This doesn't seem to be a valid URL";
        break;
      case 1 :
        let match$1 = setting[0];
        switch (match$1) {
          case "billing" :
            tmp$1 = billingEnabled ? JsxRuntime.jsx(BillingSettingsPageRelay.make, {}) : "This doesn't seem to be a valid URL";
            break;
          case "email_notifications" :
            tmp$1 = JsxRuntime.jsx(EmailPreferencesPageRelay.make, {});
            break;
          case "marketing_profile" :
            tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSettings.make, {});
            break;
          case "password" :
            tmp$1 = JsxRuntime.jsx(PasswordPage.make, {});
            break;
          case "profile" :
            tmp$1 = JsxRuntime.jsx(ProfilePage.make, {});
            break;
          case "team_marketing_profile" :
            tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSettings.make, {});
            break;
          case "users" :
            tmp$1 = JsxRuntime.jsx(SubusersPageRelay.make, {});
            break;
          default:
            tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 2 :
        let match$2 = setting[0];
        switch (match$2) {
          case "marketing_profile" :
            let match$3 = setting[1];
            switch (match$3) {
              case "about" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileAboutSettings.make, {});
                break;
              case "basic_info" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings.make, {});
                break;
              case "photos" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfilePhotosSettings.make, {});
                break;
              case "social_media" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSocialAccountsSettings.make, {});
                break;
              case "url" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSlugForm.make, {});
                break;
              default:
                tmp$1 = "This doesn't seem to be a valid URL";
            }
            break;
          case "team_marketing_profile" :
            let match$4 = setting[1];
            switch (match$4) {
              case "about" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileAboutSettings.make, {});
                break;
              case "basic_info" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings.make, {});
                break;
              case "members" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileMembersSettings.make, {});
                break;
              case "new" :
                tmp$1 = JsxRuntime.jsx(CreateTeamMarketingProfile.make, {});
                break;
              case "photos" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfilePhotosSettings.make, {});
                break;
              case "social_media" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings.make, {});
                break;
              case "url" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSlugForm.make, {});
                break;
              default:
                tmp$1 = "This doesn't seem to be a valid URL";
            }
            break;
          default:
            tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 3 :
        let match$5 = setting[0];
        if (match$5 === "team_marketing_profile") {
          let match$6 = setting[1];
          if (match$6 === "members") {
            let match$7 = setting[2];
            tmp$1 = match$7 === "new" ? JsxRuntime.jsx(AddMemberToMarketingProfile.make, {}) : "This doesn't seem to be a valid URL";
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
        } else {
          tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 4 :
        let match$8 = setting[0];
        if (match$8 === "team_marketing_profile") {
          let match$9 = setting[1];
          if (match$9 === "members") {
            let memberId = setting[2];
            let match$10 = setting[3];
            tmp$1 = match$10 === "edit" ? JsxRuntime.jsx(EditMarketingProfileMember.make, {
                memberId: memberId
              }) : "This doesn't seem to be a valid URL";
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
        } else {
          tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: tmp
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SettingsPageSidebar.make, {}),
            className: "col-span-12 md:col-span-4 lg:col-span-3 mb-8 md:mb-0"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: _error => {
                let tmp;
                if (setting.length !== 1) {
                  tmp = "There was an error loading your settings. Please try again later.";
                } else {
                  let match = setting[0];
                  switch (match) {
                    case "marketing_profile" :
                    case "team_marketing_profile" :
                      tmp = "There was an error loading your marketing profile. Please try again later.";
                      break;
                    default:
                      tmp = "There was an error loading your settings. Please try again later.";
                  }
                }
                return JsxRuntime.jsx(Alert.$$Error.make, {
                  title: tmp,
                  className: "shadow-sm"
                });
              },
              children: tmp$1
            }),
            className: "col-span-12 md:col-span-8 lg:col-span-9"
          })
        ],
        className: "grid grid-cols-12 gap-x-4"
      })
    ]
  });
}

let Page = {
  make: AccountSettingsPage$Page
};

function AccountSettingsPage$default(props) {
  let setting = props.setting;
  let setting$1 = (setting == null) ? undefined : Primitive_option.some(setting);
  let router = Next.useRouter();
  React.useEffect(() => {
    if (setting == null) {
      Next.Router.replace("/account/profile", undefined, undefined, router);
    }
  }, [setting$1]);
  return JsxRuntime.jsx(LoggedInAgent.Provider.make, {
    children: JsxRuntime.jsx(AccountSettingsPage$Page, {
      setting: setting$1
    })
  });
}

let $$default = AccountSettingsPage$default;

exports.Page = Page;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
